module.exports = __webpack_public_path__ + "static/media/crop.bf8f39ef.jpg";